/**
 * El salt de pagina en triar una talla.
 *
 * EL PROBLEMA. En clicar una opcio, la pagina saltava amunt de cop (mesurat:
 * de 600px a 67px).
 *
 * QUE NO ERA (tot verificat en viu abans d'arribar aqui):
 *   - cap `scrollTo`, `scrollIntoView` ni `jQuery.animate`: interceptats tots
 *     tres, no hi havia ni una crida;
 *   - el `ccScrollToMedia` del tema: el setting "Scroll to the relevant media"
 *     ja esta desactivat a les plantilles i l'event no es disparava;
 *   - la posicio del radio ni el seu `clip`: canviats tots dos, saltava igual.
 *
 * QUE ERA. El `focus()` sobre el radio amagat. Aïllat cridant-lo tot sol,
 * sense clic ni canvi de variant: la pagina es movia igualment. El navegador
 * desplaça la pagina per portar a la vista l'element que rep el focus.
 *
 * LA SOLUCIO. `focus({ preventScroll: true })` demana el focus SENSE aquell
 * desplacament. Es aplica nomes als radios de les opcions de producte, de
 * manera que la resta de la web no en queda afectada.
 *
 * ⚠️ El focus NO es treu: ha de seguir funcionant per a qui navega amb teclat,
 * i el tema el fa servir per pintar el contorn (`focus-label`). Aixo nomes
 * canvia COM s'hi arriba, no si s'hi arriba.
 */
(function () {
  'use strict';

  var SELECTOR = '.option-selector__btns input.opt-btn';

  // 1) Quan el focus arriba per `.focus()` (el tema el crida en alguns punts),
  //    es demana sense desplacament.
  var nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options) {
    if (this.matches && this.matches(SELECTOR)) {
      return nativeFocus.call(this, { preventScroll: true });
    }
    return nativeFocus.call(this, options);
  };

  // 2) En un CLIC, pero, el navegador dona el focus ell mateix i no passa per
  //    `focus()`: el pegat de sobre no l'atrapa (verificat — amb ell posat, la
  //    pagina seguia saltant de 600 a 67).
  //
  //    S'anota la posicio just abans que el focus es mogui i es restaura de
  //    seguida. El `mousedown` es dispara ABANS del focus, que es exactament
  //    on cal llegir-la.
  var y = null;

  document.addEventListener(
    'mousedown',
    function (evt) {
      if (evt.target.closest && evt.target.closest('.option-selector__btns')) {
        y = window.scrollY;
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (evt) {
      if (y === null) return;
      if (evt.target.matches && evt.target.matches(SELECTOR)) {
        var target = y;
        y = null;
        // Immediatament: el salt encara no s'ha pintat, de manera que no es
        // veu cap moviment.
        if (window.scrollY !== target) window.scrollTo(0, target);
        // I un cop mes al seguent fotograma, per si el navegador el torna a
        // moure despres de repintar.
        requestAnimationFrame(function () {
          if (window.scrollY !== target) window.scrollTo(0, target);
        });
      }
    },
    true
  );
})();
